import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import { appInsightsConfig, appVersion } from "../environmentConfiguration";

let applicationInsights: ApplicationInsights | undefined;

export const trackException = (error: unknown, context?: string): void => {
  if (!applicationInsights) {
    return;
  }

  const exception = error instanceof Error ? error : new Error(String(error));

  applicationInsights?.trackException({ exception }, { ...(context && { context }) });
};

export const initializeAppInsights = (): void => {
  const connectionString = appInsightsConfig.connectionString.trim();

  if (!connectionString || applicationInsights) {
    return;
  }

  applicationInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableUnhandledPromiseRejectionTracking: true,
    },
  });

  applicationInsights.addTelemetryInitializer(telemetryItem => {
    telemetryItem.data = telemetryItem.data ?? {};
    telemetryItem.data.appVersion = appVersion;
  });

  applicationInsights.loadAppInsights();
};

export const setAuthenticatedUserContext = (userId: string): void => {
  applicationInsights?.setAuthenticatedUserContext(userId);
};

export const clearAuthenticatedUserContext = (): void => {
  applicationInsights?.clearAuthenticatedUserContext();
};
